module.exports = __webpack_public_path__ + "static/media/1020250.5bb9040a.png";